import React from 'react'
import { Route, Switch } from 'react-router'
import {
  ScrapingTestCasesPage,
  ScrapingSessionPage,
  ScrapingSessionsPage,
  ScrapingTagsPage,
} from './pages'

const ScrapingRouter = () => (
  <Switch>
    <Route
      exact
      path="/scraping/sessions/management/:sessionId"
      component={ScrapingSessionPage}
    />
    <Route path="/scraping/test-cases" component={ScrapingTestCasesPage} />
    <Route path="/scraping/tags" component={ScrapingTagsPage} />
    <Route path="/scraping/sessions" component={ScrapingSessionsPage} />
  </Switch>
)

export default ScrapingRouter
